import React, { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { KeyRound } from "lucide-react";

export default function ChangePassword({ collapsed }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current: "", new: "", again: "" });
  const save = async () => {
    if (f.new !== f.again) { toast.error("YENİ ŞİFRELER AYNI DEĞİL"); return; }
    try { await api.post("/auth/change-password", { current: f.current, new: f.new }); toast.success("ŞİFRENİZ DEĞİŞTİRİLDİ"); setOpen(false); setF({ current: "", new: "", again: "" }); }
    catch (e) { const d = e.response?.data?.detail; toast.error(typeof d === "string" ? d : "ŞİFRE DEĞİŞTİRİLEMEDİ"); }
  };
  const inp = "h-10 border-slate-700 bg-slate-800 text-slate-100";
  return (
    <>
      <button data-testid="change-password-button" onClick={() => setOpen(true)} className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-semibold text-slate-300 hover:bg-slate-800">
        <KeyRound className="h-[18px] w-[18px]" />{!collapsed && <span>ŞİFREMİ DEĞİŞTİR</span>}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="change-password-dialog" className="max-w-sm border-slate-700 bg-slate-900 text-slate-100">
          <DialogHeader><DialogTitle>ŞİFREMİ DEĞİŞTİR</DialogTitle><DialogDescription className="text-slate-400">YENİ ŞİFRE EN AZ 6 KARAKTER OLMALI.</DialogDescription></DialogHeader>
          <Input data-testid="pw-current" type="password" placeholder="MEVCUT ŞİFRE" value={f.current} onChange={(e) => setF((o) => ({ ...o, current: e.target.value }))} className={inp} />
          <Input data-testid="pw-new" type="password" placeholder="YENİ ŞİFRE" value={f.new} onChange={(e) => setF((o) => ({ ...o, new: e.target.value }))} className={inp} />
          <Input data-testid="pw-again" type="password" placeholder="YENİ ŞİFRE (TEKRAR)" value={f.again} onChange={(e) => setF((o) => ({ ...o, again: e.target.value }))} className={inp} />
          <Button data-testid="pw-save" onClick={save} className="bg-blue-600 text-white hover:bg-blue-700">KAYDET</Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
